<template>
  <table class="striped admin-wheelchair-accessories-table">
    <caption v-html="caption" v-if="caption" />
    <thead>
      <tr>
        <th>Accessory</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="accessory in paginatedAccessories"
        :key="accessory.id"
        :class="selectedId === accessory.id ? 'selected' : 'selectable'"
        @click="handleSelect(accessory)"
      >
        <td>{{ accessory.name }}</td>
      </tr>
      <tr v-if="accessories.length === 0">
        <td class="no-records">
          There are currently no accessories in the system.
        </td>
      </tr>
    </tbody>
    <tfoot v-if="hasPages">
      <tr>
        <td class="page-controls">
          <icon-button
            :disabled="!hasPrevPage"
            name="prev"
            @click="goToPrevPage"
          />

          <icon-button
            :disabled="!hasNextPage"
            name="next"
            @click="goToNextPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { pagination } from "../../mixins/pagination";

export default {
  mixins: [pagination("accessories")],

  props: {
    accessories: {
      type: Array,
    },
    caption: {
      type: String,
      default: undefined,
    },
    selectedId: {
      type: Number,
      default: -1,
    },
  },

  methods: {
    handleSelect(accessory) {
      this.$emit("select", accessory);
    },
  },
};
</script>